import { motion } from 'framer-motion'
import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  CloundArrowUp,
  Stars,
  Trash
} from '../../../assets/svgs/icons'
import { FooterNaviBar } from '../../../components/FooterNaviBar'
import Loading from '../../../components/Loading'
import {
  BusinessService,
  EditorialLineService,
  EventMapService,
  LogosService,
  OrchestratorImageGenerationService,
  OrchestratorTextGenerationService,
  ProductService,
  PythonService,
  TargetAudienceService,
  UserAccountsService,
  VoiceToneService,
} from '../../../services'
import { notifyErrorCustom } from '../../../utils/notify'
import PropTypes from 'prop-types'
import styles from './styles.module.css'
// import { FirstMissionContext } from '../../../contexts/userMissions/CheckUserMissionContext'

const STEPS = {
  STEP_PASS_TYPOGRAPHY: 'stepTypography',

  STEP_PASS_IMAGE: 'stepImage',
}
const storage = window.localStorage

function StepLogo({
  setStep,
  logoSelectedArray,
  setLogoSelectedArray,
  changesStep,
}) {
  const [imageHorizontalArrayGet, setImageHorizontalArrayGet] = useState([])

  const [progress, setProgress] = useState(0)
  const [isLoading, setIsLoading] = useState(false)
  const [base64, setBase64] = useState(null)

  const { t } = useTranslation()
  const [percentage, setPercentage] = useState(0)
  const [loading, setLoading] = useState(false)

  const location = useLocation()
  const navigation = useNavigate()

  // const {mission} = useContext(FirstMissionContext)
  useEffect(() => {
    const timer = setInterval(() => {
      if (percentage < 100 && logoSelectedArray) {
        setPercentage((prevState) => prevState + 1)
      }
    }, 1)

    return () => clearInterval(timer)
  }, [logoSelectedArray, percentage])

  const stepsArray = [
    {
      pass: '1º Passo',
      title: 'Nicho e Objetivo',
      current: true,
    },
    {
      pass: '2º Passo',
      title: 'Paleta de cores',
      current: true,
    },
    {
      pass: '3º Passo',
      title: 'Fontes',
      current: true,
    },
    {
      pass: '4º Passo',
      title: 'BPS',
      current: true,
    },
    {
      pass: '5º Passo',
      title: 'Tom de Voz',
      current: true,
    },
    {
      pass: '6º Passo',
      title: 'Objetivo',
      current: true,
    },
    {
      pass: '7º Passo',
      title: 'Logo',
      current: true,
    },
    {
      pass: '8º Passo',
      title: 'Imagem',
      current: false,
    },
    {
      pass: '9º Passo',
      title: 'Geração de Arte',
      current: false,
    },
    {
      pass: '10º Passo',
      title: 'Download',
      current: false,
    },
  ]

  useEffect(() => {
    getLogos()
  }, [])

  const getLogos = async () => {
    let businessId

    const { data } = await BusinessService.getBusinessByLogin()
    businessId = data[0]?.uuid

    const { data: dataLogo } = await LogosService.getLogosById(businessId)

    if (dataLogo.length > 0) {
      const base64 = await LogosService.getLogosByBase64(dataLogo[0].uuid)
      setBase64(base64.data)
    }

    setImageHorizontalArrayGet(dataLogo)
  }

  const handleRemoveBackground = async (index, base64) => {
    setIsLoading(true) // Indica que o processo começou
    setProgress(10) // Progresso inicial

    try {
      // Faz a chamada ao serviço Python
      // const { data } = await PythonService.postRemoveBackground({
      //   image: base64,
      // })
      const { data } = await OrchestratorImageGenerationService.removeBackground({
        image: base64,
      })
      setProgress(50) // Atualiza o progresso após a chamada

      const noBgImage = data?.images

      // Atualiza os dados da imagem
      logoSelectedArray[index].fileDataBase64 = noBgImage[1]?.image
      logoSelectedArray[index].isOriginal = noBgImage[1]?.isOriginal
      setProgress(80) // Progresso ao finalizar a atualização da imagem

      setLogoSelectedArray([...logoSelectedArray]) // Atualiza o estado
      changesStep.current = true
      setProgress(100) // Progresso final
    } catch (error) {
      console.error(t('fast_publishing_error_removing_background'), error)
    } finally {
      setTimeout(() => {
        setIsLoading(false) // Oculta a barra de progresso
        setProgress(0) // Reseta o progresso
      }, 500) // Pequeno delay para exibir a barra de progresso finalizada
    }
  }

  const onDragOver = (event) => {
    event.preventDefault()
    // setDropzoneHover(true)
  }

  const onDragLeave = () => {
    // setDropzoneHover(false)
  }

  const onDrop = (event) => {
    event.preventDefault()
    event.stopPropagation()
    // setDropzoneHover(false)

    Array.from(event.dataTransfer.files).forEach((file) => {
      const reader = new FileReader()

      reader.onload = function () {
        let fileDataBase64 = reader.result

        let fileDataReturn = {
          fileDataBase64,
          name: file.name,
          size: file.size,
          type: file.type,
          origin: 'gallery',
          backgroundRemoved: false,
        }

        setLogoSelectedArray([fileDataReturn])
        changesStep.current = true
      }

      reader.readAsDataURL(file)
    })
  }

  function onFileChange(e) {

    Array.from(e.target.files).forEach((file) => {
      const reader = new FileReader()

      reader.onload = function (event) {
        let fileDataBase64 = reader.result

        let fileDataReturn = {
          fileDataBase64,
          name: file.name,
          size: file.size,
          type: file.type,
          backgroundRemoved: false,
        }

        setLogoSelectedArray([fileDataReturn])
        changesStep.current = true
      }

      reader.readAsDataURL(file)
    })
  }

  // function formatBytes(bytes, decimals = 0) {
  //   if (bytes === 0) return '0 Bytes'

  //   const k = 1024
  //   const dm = decimals < 0 ? 0 : decimals
  //   const sizes = ['Bytes', 'KB', 'MB']

  //   const i = Math.floor(Math.log(bytes) / Math.log(k))

  //   return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
  // }

  function formatBytesToMB(bytes, decimals = 2) {
    if (bytes === 0) return '0 MB'

    const k = 1024
    return parseFloat((bytes / Math.pow(k, 2)).toFixed(decimals)) + ' MB'
  }

  const handleRemoveFile = (index) => {
    setLogoSelectedArray([])
    changesStep.current = true
  }

  const handleNavigate = async (type) => {
    if (type === 'next') {
      // if (logoSelectedArray.length === 0 && !base64) {
      //   notifyErrorCustom(
      //     t('fast_publishing_choose_an_image_for_art_generation')
      //   )
      //   return
      // }

      if (logoSelectedArray?.length > 0) await postLogos()

      if (changesStep.current) await saveEditorialLine()

      // const firstGenerateArtResponse = await UserAccountsService.getFirstGenerateArt()
      // const hasFirstGenerateArt = firstGenerateArtResponse?.data?.firstGenerateArt

      // if (mission !== 'firstMission') {
      //   navigation('/NewPublicationPageIA')
      // } else {
      //   navigation('/FirstPublication', {
      //     state: { tutorialMovie: true }
      //   })
      // }
      navigation(
        location.pathname === '/FastPublishing1' ||
          location.state?.parametersComplete
          ? '/ChatSocket'
          : '/NewPublicationPageIA'
      )
    } else {
      setStep(STEPS.STEP_PASS_TYPOGRAPHY)
    }
  }

  // const registerEvent = async (data) => {
  //   await EventMapService.postEventMap(data)
  // }


  const saveEditorialLine = async () => {
    setLoading(true)

    let retEditorialLine

    let getEditorial = []

    getEditorial = await EditorialLineService.getEditorialLinebyLogin()

    const business = await BusinessService.getBusinessByLogin()
    const product = await ProductService.getProductByNotBusinessClient()
    const targetAudience =
      await TargetAudienceService.getAllTargetAudienceByNotClientId(
        storage.i18nextLng == 'en' ? storage.i18nextLng : 'ptBR'
      )

    const voiceTune = await VoiceToneService.getVoiceToneByBusiness(
      business.data[0].uuid
    )

    const data = {
      flow: 'editorial_line',
      prompt: 'editorial_line',
      business_name: business.data[0].description,

      niche:
        business.data[0].BusinessNiche.descriptionEn === 'Other'
          ? business.data[0].otherNicheName
          : storage.i18nextLng == 'en'
            ? business.data[0].BusinessNiche.descriptionEn
            : business.data[0].BusinessNiche.description,
      subniche: business.data[0].subNiche,
      business_description: business.data[0].description,
      product: {
        name: product?.data[0]?.name ?? '',
        type: product?.data[0]?.productTypeValue ?? '',
        description: product?.data[0]?.description ?? '',
      },
      target_public: {
        name: targetAudience?.data[0]?.name ?? '',
        gender: targetAudience?.data[0]?.genderValue ?? '',
        social_class:
          targetAudience?.data[0]?.socialClassValue.join(', ') ?? '',
        profession: targetAudience?.data[0]?.profession ?? '',
        region: targetAudience?.data[0]?.stateValue ?? '',
      },
      voice_tone: voiceTune?.data[0]?.tone ?? '',
      voice_tone_description: voiceTune?.data[0]?.description ?? '',
      language:
        localStorage.i18nextLng == 'en' ? localStorage.i18nextLng : 'pt',
    }

    // retEditorialLine = await PythonService.postPromptGPT(data)
    retEditorialLine = await OrchestratorTextGenerationService.generateEditorialLine(data)


    let bodyEditorial

    bodyEditorial = {
      bodyJson: retEditorialLine?.data,
      description: 'editorial line',
    }

    if (getEditorial?.data?.length > 0) {
      await EditorialLineService.putEditorialLine(
        getEditorial?.data[0]?.uuid,
        bodyEditorial
      )
    } else {
      await EditorialLineService.postEditorialLine(bodyEditorial)
    }

    setLoading(false)
    setStep(STEPS.STEP_PASS_COLOR_PALETTE)
  }

  const postLogos = async () => {
    let businessId

    const { data } = await BusinessService.getBusinessByLogin()
    businessId = data[0]?.uuid

    let body = {}

    // Dividir a string base64 para separar o cabeçalho da imagem
    const parts = logoSelectedArray[0]?.fileDataBase64?.split(',')

    const header = parts[0]
    const base64Data = parts[1]

    // Extrair o formato do arquivo e o tipo de conteúdo
    const matches = header.match(/^data:([A-Za-z-+\/]+);base64$/)
    const fileContentType = matches[0]
    const fileFormat = fileContentType.split('/')[1]

    body = {
      businessId: businessId,
      description: logoSelectedArray[0]?.name,
      fileFormat: fileFormat,
      fileContentType: fileContentType,
      fileBase64: base64Data,
    }

    if (imageHorizontalArrayGet.length === 0) {
      await LogosService.postLogo(body)

      const dataEvenProgress = {
        event: 'parametrization_progress_updated',
        eventData: {
          step: 'Logo',
          percentComplete: '100%',
        },
      }
      //await registerEvent(dataEvenProgress)
    } else {
      body = {
        businessId: businessId,
        description: logoSelectedArray[0]?.name,
        fileFormat: fileFormat,
        fileContentType: fileContentType,
        fileBase64: base64Data,
        fileName: imageHorizontalArrayGet[0].fileName,
      }

      await LogosService.putLogos(imageHorizontalArrayGet[0]?.uuid, body)
    }

    const dataEvent = {
      event: 'logo_uploaded',
      eventData: {
        fileFormat: fileFormat,
      },
    }
    //await registerEvent(dataEvent)
  }

  const updateFirstLogin = async () => {
    const dataFirstLogin = await UserAccountsService.getUserAccountsByLogin()

    const { ...rest } = dataFirstLogin?.data

    delete rest.uuid
    delete rest.createdAt
    delete rest.updatedAt
    delete rest.deletedAt
    delete rest.PaymentHistory
    delete rest.freePlanChose
    delete rest.lastLogin

    rest.firstLogin = false
    rest.photoName = ''
    rest.photoUrl = ''

    const { data } = await UserAccountsService.putUserAccountsByLogin(rest)
  }

  return (
    <motion.div
      initial={{ x: '100vw' }}
      animate={{ x: 0 }}
      exit={{ x: '-100vw' }}
      transition={{ type: 'tween', duration: 0.5 }}
      style={{
        width: '100%',
        // height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        height: 'calc(100% - 120px)',
        overflow: 'hidden'
      }}
    >
      <Loading enable={loading} />
      <div className={styles.box_step}>
        {/* <PreviousPass steps={stepsArray}/> */}

        <div className={styles.box_page}>
          {/* <p style={{ margin: "0px" }}>{t("fast_publishing_logo_text")}</p> */}
          <h1 style={{ marginTop: '0px', fontSize: '45px', fontWeight: 500 }}>
            {t('fast_publishing_logo')}
          </h1>

          <div className={styles.container_modal}>
            <div className={styles.content_up_image}>
              <div className={styles.modal_container_drag}>
                <div className={styles.modal_drag}>
                  {/* <label htmlFor="arquivo">
                <h3>Arrase & Solte o arquivo</h3>
                <p>Ou selecione o arquivo no explorador</p>
                </label> */}

                  <div
                    className={styles.modal_drag_drop}
                    onDragOver={onDragOver}
                    onDragLeave={onDragLeave}
                    onDrop={onDrop}
                  // onClick={handleShowListImages}

                  // style={{
                  //   height: '100px',
                  //   width: '100%',
                  //   border: '2px dashed black',
                  //   backgroundColor: dropzoneHover ? 'blue' : 'red',
                  // }}
                  // className={styles.modal_drag}
                  >
                    <label htmlFor="arquivo">
                      <CloundArrowUp color={'#B900FE'} />
                      <h2
                        className={
                          logoSelectedArray.length !== 0
                            ? styles.modal_drag_drop_title_short
                            : styles.modal_drag_drop_title
                        }
                      >
                        {t('fast_publishing_drag_and_drop')}
                      </h2>
                      <p
                        className={
                          logoSelectedArray.length !== 0
                            ? styles.modal_drag_drop_sub_title_short
                            : styles.modal_drag_drop_sub_title
                        }
                      >
                        {t('fast_publishing_drag_and_drop_subtitle')}
                      </p>
                    </label>
                    <input
                      type="file"
                      name="arquivo"
                      id="arquivo"
                      onChange={(e) => onFileChange(e)}
                    ></input>
                    {/* {fileData && (
                      <img
                      style={{ width: 50, height: 50 }}
                      src={fileData}
                      alt="file-preview"
                      />
                      )} */}
                  </div>
                </div>
              </div>

              {logoSelectedArray.length !== 0 ? (
                <div className={styles.content_list_image}>
                  <div className={styles.container_box_list_image}>
                    {logoSelectedArray?.map((image, index) => (
                      <div
                        key={index}
                        className={styles.container_list_image}
                      // style={{ border: '1px solid red' }}
                      >
                        <div className={styles.item_list_image}>
                          <img
                            src={image.fileDataBase64}
                            alt="file-preview"
                            style={{
                              width: 40,
                              height: 40,
                              objectFit: 'cover',
                            }}
                          //onContextMenu={(e) => e.preventDefault()}
                          />

                          <div className={styles.box_data_info}>
                            <p className={styles.box_data_info_title}>
                              {image.name}
                            </p>
                            <p className={styles.box_data_info_size}>
                              {t('fast_publishing_logo_size_image')} &nbsp;
                              <b> {formatBytesToMB(image.size)} </b>
                            </p>
                          </div>
                        </div>
                        <div className={styles.item_list_image_buttons}>
                          <button
                            className={styles.button_cancel}
                            onClick={() => handleRemoveFile(index)}
                          >
                            <p className={styles.button_cancel_title}>
                              {t('fast_publishing_logo_size_delete_image')}
                            </p>
                            <Trash />
                          </button>

                          <button
                            className={styles.button_remove_background}
                            onClick={() =>
                              handleRemoveBackground(
                                index,
                                image.fileDataBase64
                              )
                            }
                          >
                            <p
                              className={styles.button_remove_background_title}
                            >
                              {t(
                                'fast_publishing_logo_remove_background_image'
                              )}
                            </p>
                            <Stars />
                          </button>
                        </div>
                      </div>

                      //   <motion.div
                      //   initial={{opacity:0}}
                      //   animate={{opacity:1}}
                      //   exit={{opacity:0}}
                      //   transition={{duration:0.3}}
                      //   className={styles.image_preview_container}>

                      //   <img
                      //     width={150}
                      //     height={80}
                      //     src={logoSelectedArray?.fileUrl}
                      //     alt="selected image" />
                      //   <div className={styles.progressbar_container}>

                      //     <div className={styles.label_icon_container}>
                      //       <div className={styles.progressbar_container_text}>
                      //         <p className={styles.progressbar_label}>Realizando upload</p>
                      //         <p className={styles.progressbar_percentage}>{percentage}%</p>
                      //       </div>
                      //       <div onClick={() => (console.log("teste"))} className={styles.close_button}>
                      //         <CloseIcon color='red'/>
                      //       </div>
                      //     </div>
                      //     <motion.div initial={{width:0}} animate={{width:'100%'}} className={styles.progressbar}/>
                      //   </div>

                      // </motion.div>
                    ))}
                    {isLoading && (
                      <div className={styles.progressBarContainer}>
                        <div
                          className={styles.progressBar}
                          style={{ width: `${progress}%` }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                base64 && (
                  <div className={styles.item_list_image}>
                    <img
                      src={'data:image/png;base64,' + base64}
                      alt="file-preview"
                      style={{
                        width: 40,
                        height: 40,
                        objectFit: 'cover',
                      }}
                    //onContextMenu={(e) => e.preventDefault()}
                    />

                    <div className={styles.box_data_info}>
                      <p className={styles.box_data_info_title}>{ }</p>
                      <p className={styles.box_data_info_size}>
                        {t('Logo Atual')} &nbsp;
                      </p>
                    </div>
                  </div>
                )
              )}
              <div className={styles.modal_button_save}>
                <button className={styles.button_add}>
                  <label className={styles.button_add_label} htmlFor="arquivo">
                    {logoSelectedArray.length > 0
                      ? t('fast_publishing_logo_change_image')
                      : t('fast_publishing_logo_add_image')}
                  </label>
                </button>
              </div>
            </div>
          </div>
          {/* <DragUploadRemoveBackgroundContainer
           imagesArray={'logoSelectedArray.fileDataBase64'}
           //setImagesArray={setImagesArray}
           onClickRemoveBackground={handleRemoveBackground}
           //onClickButton={(images) => setImagesArray(images)}
           textButton={'Adicionar imagem ao produto'}/> */}
        </div>
        {/* <div className={styles.box_button}>
          <button
            className={styles.back_button}
            onClick={() => handleNavigate('back')}
          >
            {t("back_buttom")}
          </button>
          <button
            className={styles.next_button}
            onClick={() => handleNavigate('next')}
          >
            {t('next_buttom')}
          </button>
        </div> */}
        <FooterNaviBar
          back={() => handleNavigate('back')}
          next={() => handleNavigate('next')}
        />
      </div>
    </motion.div>
  )
}

export default StepLogo


StepLogo.propTypes = {
  setStep: PropTypes.func,
  logoSelectedArray: PropTypes.array,
  setLogoSelectedArray: PropTypes.func,
  changesStep: PropTypes.func,
}
